import { Button, Modal, ModalActions } from '@braskai/ui-kit';

import { useInterfaceLanguage } from '@/shared/i18n';
import { ModalHeaderDefault } from '@/shared/ui/modal';

type LeaveSpaceConfirmationModalProps = {
  isLoading: boolean;
  isOpen: boolean;
  onCancel: () => void;
  onLeave: () => void;
};

export const LeaveSpaceConfirmationModal = ({
  isLoading,
  isOpen,
  onCancel,
  onLeave,
}: LeaveSpaceConfirmationModalProps) => {
  const { t } = useInterfaceLanguage();

  return (
    <Modal open={isOpen} size="xs" onClose={onCancel}>
      <ModalHeaderDefault
        title={t('teamspace.leave.title')}
        style={{
          paddingBottom: 0,
        }}
        subtitle={t('teamspace.leave.subtitle')}
        onClose={onCancel}
      />
      <ModalActions>
        <Button data-testid="leave-space-confirmation-modal-cancel" variant="outlined" fullWidth onClick={onCancel}>
          {t('teamspace.action.cancel')}
        </Button>
        <Button
          data-testid="leave-space-confirmation-modal"
          isLoading={isLoading}
          variant="error"
          fullWidth
          onClick={onLeave}
        >
          {t('teamspace.action.leave')}
        </Button>
      </ModalActions>
    </Modal>
  );
};
